export class EmissionSymbolValueConverter {
    //Add extra units param to show units in the view
    toView(value, forTotalDashboard, forChart?: boolean, units?: string) {
        const result = forTotalDashboard ? this.totalEmissionFormula(value) : this.emissionFormula(value, forChart);
        return units ? result + units: result;
    }

    //Formula for Total emissions
    totalEmissionFormula(x) {

        //Xylenes (individual or mixed isomers)
        if (x == '(CH3)2C6H4') {
            return `<span style="font-size: 1.1rem">(CH<sub>3</sub>)<sub>2</sub>C<sub>6</sub>H<sub>4</sub></span>`;
        }
        //Nitrogen Oxides
        else if (x == 'NOx') {
            return `<span>NO<sub>x</sub></span>`;
        }
        //Particulate Matter < 10.0 µm
        else if (x == 'PM10') {
            return `<span>PM<sub>10</sub></span>`;
        }
        //Carbon Dioxide
        else if (x == 'CO2') {
            return `<span>CO<sub>2</sub></span>`;
        }
        //Ethylbenzene
        else if (x == 'C6H5CH2CH3') {
            return `<span style="font-size: 1rem">C<sub>6</sub>H<sub>5</sub>CH<sub>2</sub>CH<sub>3</sub></span>`;
        }
        //Toluene (methylbenzene)
        else if (x == 'C7H8') {
            return `<span>C<sub>7</sub>H<sub>8</sub></span>`;
        }
        //Particulate Matter < 2.5 µm
        else if (x == 'PM2.5') {
            return `<span>PM<sub>2.5</sub></span>`;
        }
        //Sulphur Oxides
        else if (x == 'SOx') {
            return `<span>SO<sub>x</sub></span>`;
        }
        //Benzene
        else if (x == 'C6H6') {
            return `<span>C<sub>6</sub>H<sub>6</sub></span>`;
        }
        //Formaldehyde (methyl aldehyde)
        else if (x == 'CH2O') {
            return `<span>CH<sub>2</sub>O</span>`;
        }
        //Polychlorinated dioxins and furans 
        else if (x == 'C12H4Cl4O2') {
            return `<span style="font-size: 1rem">C<sub>12</sub>H<sub>4</sub>CI<sub>4</sub>O<sub>2</sub></span>`;
        }
        //Nitrous Oxide 
        else if (x == 'N2O') {
            return `<span>N<sub>2</sub>O</span>`;
        }
        //Methane 
        else if (x == 'CH4') {
            return `<span>CH<sub>4</sub></span>`;
        } 
        else if (x == 'Total GHG Emissions') {
            return `Total GHG (<span>CO<sub>2</sub>e</span>)`;
        }
        else {
            return x;
        }
    }

    emissionFormula(x, forChart?: boolean) {

        //Xylenes (individual or mixed isomers)
        if (x == '(CH3)2C6H4') {
            return forChart ? '(CH[baseline-shift: sub]3[baseline-shift: baseline])[baseline-shift: sub]2[baseline-shift: baseline]C[baseline-shift: sub]6[baseline-shift: baseline]H[baseline-shift: sub]4[baseline-shift: baseline]' :
                `(CH<sub>3</sub>)<sub>2</sub>C<sub>6</sub>H<sub>4</sub>`;
        }
        //Nitrogen Oxides
        else if (x == 'NOx') {
            return forChart ? 'NO[baseline-shift: sub]X[baseline-shift: baseline]' : `NO<sub>x</sub>`;
        }
        //Particulate Matter < 10.0 µm
        else if (x == 'PM10') {
            return forChart ? 'PM[baseline-shift: sub]10[baseline-shift: baseline]' : `PM<sub>10</sub>`;
        }
        //Carbon Dioxide
        else if (x == 'CO2') {
            return forChart ? 'CO[baseline-shift: sub]2[baseline-shift: baseline]' : `CO<sub>2</sub>`;
        }
        //Ethylbenzene
        else if (x == 'C6H5CH2CH3') {
            return forChart ? 'C[baseline-shift: sub]6[baseline-shift: baseline]H[baseline-shift: sub]5[baseline-shift: baseline]CH[baseline-shift: sub]2[baseline-shift: baseline]CH[baseline-shift: sub]3[baseline-shift: baseline]'
                : `C<sub>6</sub>H<sub>5</sub>CH<sub>2</sub>CH<sub>3</sub>`;
        }
        //Toluene (methylbenzene)
        else if (x == 'C7H8') {
            return forChart ? 'C[baseline-shift: sub]7[baseline-shift: baseline]H[baseline-shift: sub]8[baseline-shift: baseline]' : `C<sub>7</sub>H<sub>8</sub>`;
        }
        //Particulate Matter < 2.5 µm
        else if (x == 'PM2.5') {
            return forChart ? 'PM[baseline-shift: sub]2.5[baseline-shift: baseline]' : `PM<sub>2.5</sub>`;
        }
        //Sulphur Oxides
        else if (x == 'SOx') {
            return forChart ? 'SO[baseline-shift: sub]x[baseline-shift: baseline]' : `SO<sub>x</sub>`;
        }
        //Benzene
        else if (x == 'C6H6') {
            return forChart ? 'C[baseline-shift: sub]6[baseline-shift: baseline]H[baseline-shift: sub]6[baseline-shift: baseline]'
                : `C<sub>6</sub>H<sub>6</sub>`;
        }
        //Formaldehyde (methyl aldehyde)
        else if (x == 'CH2O') {
            return forChart ? 'CH[baseline-shift: sub]2[baseline-shift: baseline]O' : `CH<sub>2</sub>O`;
        }
        //Polychlorinated dioxins and furans 
        else if (x == 'C12H4Cl4O2') {
            return forChart ? 'C[baseline-shift: sub]12[baseline-shift: baseline]H[baseline-shift: sub]4[baseline-shift: baseline]Cl[baseline-shift: sub]4[baseline-shift: baseline]O[baseline-shift: sub]2[baseline-shift: baseline]'
                : `C<sub>12</sub>H<sub>4</sub>CI<sub>4</sub>O<sub>2</sub>`;
        }
        //Nitrous Oxide 
        else if (x == 'N2O') {
            return `<span>N<sub>2</sub>O</span>`;
        }
        //Methane 
        else if (x == 'CH4') {
            return `<span>CH<sub>4</sub></span>`;
        }
        else if (x == 'Total GHG Emissions') {
            return `Total GHG Emissions (<span>tCO<sub>2</sub>e_100yr</span>)`;
        }
        else {
            return x;
        }
    }
}
